/* eslint-disable eqeqeq */
import i18next from 'i18next';
import moment from 'moment';
import videojs from 'video.js';

const getErrorArrays = error => {
  if (!error['Validation Failed']) return null;
  const errors = error['Validation Failed'];
  const messages = Object.values(errors);
  if (!messages) return null;
  let result = '';
  messages.map(item => (result += `${item} \n`));
  return result;
};

export const getErrorCode = err => {
  if (!err) return null;
  const { response } = err;
  if (!response || !response.data) return null;
  const { status, data } = response;
  return { status, error: data.error };
};

export const getError = err => {
  if (err && err.response && err.response.data) {
    const msg = err.response.data.message || err.response.data.error;
    const error = getErrorArrays(err.response.data);
    if (error) return error;
    if (msg) return msg;
  }
  if (err && err.response && err.response.statusText) {
    return err && err.response && err.response.statusText;
  }
  if (err && err.data && err.data.message) {
    return err.data.message;
  }
  if (err && err.message) {
    return err.message;
  }
  return err;
};

export const getDeviceId = () => {
  const storageId = localStorage.getItem('device_id');
  if (storageId) return storageId;
  const navigator_info = window.navigator;
  const screen_info = window.screen;
  let uid = navigator_info.mimeTypes.length;
  uid += navigator_info.userAgent.replace(/\D+/g, '');
  uid += navigator_info.plugins.length;
  uid += screen_info.height || '';
  uid += screen_info.width || '';
  uid += screen_info.pixelDepth || '';
  localStorage.setItem('device_id', uid);
  return uid;
};

export const isMobileOrTablet = () => {
  let check = false;
  // eslint-disable-next-line
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

export const isSmartTVBrowser = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('smarttv') || userAgent.includes('smart-tv');
};

export const getSize = (width, original) => {
  return (width * original) / 1920;
};

export const getDurationSec = duration => {
  const time = moment.utc(duration);
  return new Date(time).getTime() / 1000;
};

export const bindDuration = duration => {
  if (!duration) return null;
  const time = moment.utc(duration);
  const hour = time.format('H');
  const minutes = time.format('m');
  const labelH = i18next.t('time_h');
  const labelM = i18next.t('time_m');
  return `${Number(hour) ? `${hour}${labelH}` : ''} ${
    Number(minutes) ? `${minutes}${labelM}` : ''
  }`.trim();
};

export const getLang = () => {
  return i18next.language.split('-')[0];
};

export const isMobileSize = width => {
  return width < 667;
};

export const isTabletSize = width => {
  return width >= 667 && width < 1024;
};

export const detectBrowser = () => {
  const { IS_CHROME, IS_ANY_SAFARI, IS_FIREFOX, IS_EDGE } = videojs.browser;

  if (IS_ANY_SAFARI) return 'safari';
  if (IS_CHROME) return 'chrome';
  if (IS_FIREFOX) return 'firefox';
  if (IS_EDGE) return 'edge';

  return 'chrome';
};

export const isOpera = !!navigator.userAgent.match(/Opera|OPR\//);

export const isChromeOrSafari = () => {
  return (videojs.browser.IS_ANY_SAFARI || videojs.browser.IS_CHROME) && !isOpera;
};

export const getDeviceType = () => {
  return `web_${detectBrowser()}`;
};

export const getFileExt = file => {
  return file.substr(file.lastIndexOf('.') + 1);
};

export const isHls = url => {
  return getFileExt(url) === 'm3u8';
};

export const getDeviceHeader = () => {
  return {
    headers: {
      common: {
        'device-type': getDeviceType(),
      },
    },
  };
};

export const getMobileOperatingSystem = () => {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return 'android';
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'ios';
  }

  return 'android';
};

export const getArrayIds = arr => {
  return arr.map(i => ({ id: i.id }));
};

const isHLS = videojs.browser.IS_ANY_SAFARI || videojs.browser.IS_IOS;

export const drmType = isHLS ? 'FAIRPLAY' : 'WIDEVINE';
export const streamType = isHLS ? 'hls' : 'dash';

export const getCaptcha = (action = 'send_email') => {
  return new Promise((resolve, reject) => {
    if (window.grecaptcha === undefined) {
      reject('reCAPTCHA failed');
    }
    try {
      window.grecaptcha.enterprise.ready(function() {
        window.grecaptcha.enterprise
          .execute('6LdIwEAjAAAAAHQ0C5boXWZ1_afrm3AnJqxYonWC', { action })
          .then(resolve, () => {
            reject('reCAPTCHA failed');
          })
          .catch(() => reject('reCAPTCHA failed'));
      });
    } catch (err) {
      reject('reCAPTCHA failed');
    }
  });
};

export const arrayToList = (arr, key) => {
  return []
    .concat(arr || {})
    .map(item => item[key])
    .join(', ');
};

export const getDeviceInfo = () => {
  let nAgt = navigator.userAgent;
  let browserName = navigator.appName;
  let fullVersion = '' + parseFloat(navigator.appVersion);
  let majorVersion = parseInt(navigator.appVersion, 10);
  let nameOffset, verOffset, ix;

  // In Opera, the true version is after "OPR" or after "Version"
  if ((verOffset = nAgt.indexOf('OPR')) != -1) {
    browserName = 'Opera';
    fullVersion = nAgt.substring(verOffset + 4);
    if ((verOffset = nAgt.indexOf('Version')) != -1) fullVersion = nAgt.substring(verOffset + 8);
  }
  // In MS Edge, the true version is after "Edg" in userAgent
  else if ((verOffset = nAgt.indexOf('Edg')) != -1) {
    browserName = 'Microsoft Edge';
    fullVersion = nAgt.substring(verOffset + 4);
  }
  // In MSIE, the true version is after "MSIE" in userAgent
  else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
    browserName = 'Microsoft Internet Explorer';
    fullVersion = nAgt.substring(verOffset + 5);
  }
  // In Chrome, the true version is after "Chrome"
  else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
    browserName = 'Chrome';
    fullVersion = nAgt.substring(verOffset + 7);
  }
  // In Safari, the true version is after "Safari" or after "Version"
  else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
    browserName = 'Safari';
    fullVersion = nAgt.substring(verOffset + 7);
    if ((verOffset = nAgt.indexOf('Version')) != -1) fullVersion = nAgt.substring(verOffset + 8);
  }
  // In Firefox, the true version is after "Firefox"
  else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
    browserName = 'Firefox';
    fullVersion = nAgt.substring(verOffset + 8);
  }
  // In most other browsers, "name/version" is at the end of userAgent
  else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
    browserName = nAgt.substring(nameOffset, verOffset);
    fullVersion = nAgt.substring(verOffset + 1);
    if (browserName.toLowerCase() == browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
  }
  // trim the fullVersion string at semicolon/space if present
  if ((ix = fullVersion.indexOf(';')) != -1) fullVersion = fullVersion.substring(0, ix);
  if ((ix = fullVersion.indexOf(' ')) != -1) fullVersion = fullVersion.substring(0, ix);

  majorVersion = parseInt('' + fullVersion, 10);
  if (isNaN(majorVersion)) {
    fullVersion = '' + parseFloat(navigator.appVersion);
    majorVersion = parseInt(navigator.appVersion, 10);
  }

  // Get OS name and version
  const osName = (() => {
    const { appVersion } = navigator;
    if (appVersion.indexOf('Win') !== -1) return 'Windows';
    if (appVersion.indexOf('Mac') !== -1) return 'MacOS';
    if (appVersion.indexOf('X11') !== -1) return 'UNIX';
    if (appVersion.indexOf('Linux') !== -1) return 'Linux';
    return 'Unknown';
  })();

  const osVersion = (() => {
    const { appVersion } = navigator;
    const version = appVersion.split(/[()]/)[1];
    return version ? version : 'Unknown';
  })();

  return {
    browser: browserName,
    version: fullVersion,
    majorVersion,
    appName: navigator.appName,
    userAgent: navigator.userAgent,
    os: osName,
    osVersion: osVersion,
  };
};

// const isWebglSupported = () => {
//   try {
//     var canvas = document.createElement('canvas');
//     return (
//       !!window.WebGLRenderingContext &&
//       (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
//     );
//   } catch (e) {
//     return false;
//   }
// };

export const isOpenedOnMobile = () => {
  const isTouch = window.matchMedia('(pointer: coarse)').matches;
  if (isTouch) return true;
  return false;
};

export const isHardwareSupported = () => {
  if (isOpenedOnMobile()) {
    return false;
  }

  return true;
  // if (videojs.browser.IS_CHROME && !isWebglSupported()) {
  //   return false;
  // }

  // return true;
};

export const showMediaDetailBanner = (account, userInfo) => {
  const userCountry = userInfo?.location?.country_code;
  const bannerConfig = account?.media_detail_banner_config;
  const isCountriesEmpty = !bannerConfig?.available_country?.length;
  const showBanner = isCountriesEmpty || bannerConfig?.available_country?.includes(userCountry);
  return showBanner;
};

export const toggleFeedbackChat = show => {
  const feedbackChat = document.querySelector('feedback-one');
  if (feedbackChat) {
    feedbackChat.style.display = show ? 'block' : 'none';
  }
};
